module.exports = __webpack_public_path__ + "static/media/inferno.74bcf09a.jpg";